import SectionTitle from 'components/Globals/SectionTitle';
import { NextCustomImage } from 'components/Image';
import Link from 'components/Globals/Base/Link';
import * as S from './TopicRankingStyling';

const TopicRanking = ({ rankingPanel }) => (
  <S.RankingContainer>
    <S.TitleWrapper>
      <SectionTitle
        tag='h2'
        text='Fortune 500 rankings'
        variant='border'
      />
    </S.TitleWrapper>

    <S.RankingSection>
      {rankingPanel.map((ranking) => {
        const yearsDesc = [...(ranking.years || [])].sort((a, b) => Number(b.year) - Number(a.year));
        const latestYear = yearsDesc[0];

        const rankingUrl = ranking.listTypeAlias === 'external' ? ranking.externalUrl : ranking.slug;

        return (
          <S.RankingWrapper key={ranking.image}>
            <Link
              href={rankingUrl}
              type='image'
            >
              <NextCustomImage
                className='next-img'
                src={ranking.image}
                alt={ranking.imageAlt}
                style={{ height: 'auto', width: 'auto' }}
                width='1'
                height='1'
              />
            </Link>

            <Link
              href={rankingUrl}
              className='title'
              dataCy='title'
            >
              {ranking.title}
            </Link>
            <S.Description>{ranking.description}</S.Description>

            <S.BottomSection>
              <Link
                className='black-button'
                type='primaryButton'
                size={{ default: 'large' }}
                href={rankingUrl}
                hasRightArrow={false}
                dataCy='btnViewList'
              >
                {`VIEW ${latestYear?.year} LIST`}
              </Link>
            </S.BottomSection>
          </S.RankingWrapper>
        );
      })}
    </S.RankingSection>
  </S.RankingContainer>
);

export default TopicRanking;
